import React, { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import {
  HvButton,
  HvDialog,
  HvDialogTitle,
  HvDialogContent,
  HvDialogActions,
} from "@hitachivantara/uikit-react-core";

import useStyles from "./styles";

interface ConfirmationDialogProps {
  title: string;
  message: string;
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  closeButtonTooltip?: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = (props) => {
  const { t } = useTranslation("common");

  const {
    title,
    message,
    isOpen,
    onConfirm,
    onCancel,
    confirmButtonLabel = t("confirmationDialog.yes"),
    cancelButtonLabel = t("confirmationDialog.no"),
    closeButtonTooltip = t("confirmationDialog.close"),
  } = props;

  const classes = useStyles();

  const handleClose = (
    event: MouseEventHandler<HTMLButtonElement>,
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (reason !== "backdropClick") {
      onCancel?.();
    }
  };

  return (
    <HvDialog
      classes={{ paper: classes.paper }}
      open={isOpen}
      onClose={handleClose}
      firstFocusable="confirmation-dialog-cancel"
      buttonTitle={closeButtonTooltip}
    >
      <HvDialogTitle variant="warning">{title}</HvDialogTitle>
      <HvDialogContent indentContent>{message}</HvDialogContent>
      <HvDialogActions>
        <HvButton category="ghost" onClick={onConfirm}>
          {confirmButtonLabel}
        </HvButton>
        <HvButton
          id="confirmation-dialog-cancel"
          category="ghost"
          onClick={() => onCancel?.()}
        >
          {cancelButtonLabel}
        </HvButton>
      </HvDialogActions>
    </HvDialog>
  );
};

export default ConfirmationDialog;
